module.exports = __webpack_public_path__ + "img/tick.af1537a7.svg";